import { Box, Flex, Grid, Link, Text } from '@chakra-ui/react'
import { Section } from '@/components/layout'
import { SectionLabel } from '@/components/typography'
import { Btn } from '@/components/ui/Btn'
import { useLocale } from '@/i18n'
import { CONTACT_INFO } from './contact.data'

export const Contact = () => {
  const { locale } = useLocale()
  const contact = CONTACT_INFO[locale]

  return (
    <Section id="contact" pt="clamp(44px, 5.5vw, 72px)" pb="clamp(52px, 6vw, 80px)">
      <SectionLabel mb="32px">{contact.sectionLabel}</SectionLabel>
      <Grid
        templateColumns="repeat(auto-fit, minmax(min(320px, 100%), 1fr))"
        gap="clamp(32px, 4vw, 64px)"
        alignItems="start"
      >
        <Box>
          <Text
            mb="32px"
            fontFamily="heading"
            fontWeight="800"
            fontSize="clamp(26px, 2.4vw, 40px)"
            lineHeight="1.16"
            letterSpacing="-0.03em"
          >
            {contact.availability}
          </Text>
          <Flex gap="40px" flexWrap="wrap" borderTop="2px solid" borderColor="divider" pt="20px">
            <Link
              href={`mailto:${contact.email}`}
              fontFamily="heading"
              fontWeight="800"
              fontSize="20px"
              letterSpacing="-0.01em"
              color="accent"
              textDecoration="none"
              _hover={{ color: 'accent.600' }}
            >
              {contact.email}
            </Link>
            <Text
              fontSize="13px"
              letterSpacing="0.12em"
              textTransform="uppercase"
              alignSelf="center"
              color="muted"
            >
              {contact.location}
            </Text>
          </Flex>
        </Box>
        <Flex direction="column" gap="12px">
          <Btn
            href={contact.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            variant="primary"
            block
            fontSize="16px"
            p="20px"
          >
            {contact.ctaLabel}
          </Btn>
          <Btn
            href={contact.auditBookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            variant="secondary"
            block
            fontSize="16px"
            p="20px"
          >
            {contact.auditCtaLabel}
          </Btn>
        </Flex>
      </Grid>
    </Section>
  )
}
